import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsWidgetConfigurationRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-widget-configuration',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/widget-configuration',
	exact: true,
};
